import { ProductItem } from '@grupoboticario/barril-del-chavo'
import { CSS } from '@grupoboticario/flora-react'
import { IProduct } from 'src/@interfaces'

export enum ShopWindowType {
  PROMPT_DELIVERY = 'Pronta-entrega',
  ON_SALE = 'Promoções',
  BEST_SELLERS = 'Mais vendidos',
  CAMPAIGN = 'Presentes até 30% OFF',
}

export interface ShopWindowProps {
  products: ProductItem[]
}

export interface ShopWindowProductCardProps {
  /** Objeto com os dados do produto */
  product: IProduct

  /** Indice de posição quando utilizado em uma lista. */
  index?: number

  /** Nome da vitrine utilizada na lista */
  shopWindowType: ShopWindowType

  /** Nome da página que o card se encontra */
  listName?: string
}

export type CarouselShopProps = {
  products: ProductItem[]
  slidesToShow?: number
  shopWidth?: string
  shopWindowType: ShopWindowType
  isMobile: boolean
}

export interface IWishlistToggleVariants {
  topLeftCorner: CSS
  topRightCorner: CSS
  relative: CSS
}

export const WishlistToggleVariants: IWishlistToggleVariants = {
  topLeftCorner: {
    position: 'absolute',
    top: '0',
    left: '0',
  },
  topRightCorner: {
    position: 'absolute',
    top: '0',
    right: '0',
  },
  relative: {
    position: 'relative',
  },
}

export const ITEM_LIST_NAME_MAP = {
  [ShopWindowType.BEST_SELLERS]: 'Itens mais vendidos',
  [ShopWindowType.PROMPT_DELIVERY]: 'Pronta entrega',
  [ShopWindowType.ON_SALE]: 'Promoção',
  [ShopWindowType.CAMPAIGN]: 'Presentes até 30% OFF',
}

export type ShopWindowItemProps = {
  products?: ProductItem[]
  shopWindowType: ShopWindowType
  shopWidth: string
  slidesToShow?: number
  isMobile: boolean
  isLoading: boolean
  seeMoreUrl?: string
}
